import './subHeading.css'

export default function SubHeading({ title, color }) {
  return (
    <div className={'subheading'}>
      <h1 className={`${color ? 'main-color' : 'white-color'}`}>{title}</h1>
    </div>
  )
}